import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";
import { ExportTable } from "../ExportTable/ExportTable";

import { ExportIntegrations } from "app/pages/sales-intelligence/pages/management/types/types";

export const CompanyAsLeads = () => {
    const { integrationName } = getIntegrationNameFromUrl();

    if (integrationName === ExportIntegrations.hubspot) {return null;}

    return <ExportTable exportName="companyAsLeads" />;
};
